import { ApiService } from './api.service'

const BaseUrl = '/quopay'

export function quopayExchangePoint (params = {}) {
  return ApiService.post(`${BaseUrl}/exchange`, params).then(resp => resp.data)
}
